import React from "react";
import { Link, useNavigate } from "react-router-dom";

import courseImg1 from "../../assets/images/course/1.png";

const SingleCourse = (props) => {
  const navigate = useNavigate();
  const { course,name} = props;

  const handleClick = () => {
    // Use navigate to redirect to the course detail page and pass the course data in the state
    navigate(`/coursesDetail/${course.name}`, { state: { course:course,name:name } });
  };
  return (
    <div className="" onClick={handleClick}> 
      <div className="course__item mb-30">
        <div className="course__thumb">
        <img crossorigin="anonymous"
              src={
               course.thumbnail
                  ? `https://back.yourfrenchteachers.com/${course.thumbnail}`
                  : courseImg1
              }
              alt={course.name}
            />
        </div>
        <div className="course__inner">
          {/* <ul>
          <li>{courseName ? courseName : "UX Design"}</li>
          <li>{courseLesson ? courseLesson : "4"} Lessons</li>
          </ul> */}
          <h3 className="react-course-title">
            <Link to={`/course/${course._id}`}>
              {course.name
                ? course.name
                : "Dave conservatoire is the Entirely free online."}
            </Link>
          </h3>
          <div className="course__card-icon d-flex align-items-center">
           {
            course?.lectureCount>0 && (
               <div className="course__card-icon--1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-book"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
              <span>{course.lectureCount ? course.lectureCount : "77"} Lecture</span>
            </div>
            )
           }
            <div className="react__user">
              {course.price ? `${course.price}` : "$68.00"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleCourse;
